import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';

import tw from '../styles/tailwind';
import Text from './Text';
import { stopImpersonation } from '../store/Reducers/impersonation';

export default function ImpersonationBanner() {
  const dispatch = useDispatch<any>();
  const impersonation = useSelector((state: any) => state.impersonation);

  if (!impersonation?.superAdminToken) return null;

  return (
    <SafeAreaView edges={['top']} style={tw`bg-yellow-400`}>
      <View style={tw`row items-center justify-between px-4 py-2`}>
        <Text style={tw`text-gray-900 flex-1`} numberOfLines={1}>
          Impersonando a {impersonation.targetUser?.name ?? 'usuario'}
        </Text>
        <TouchableOpacity
          onPress={() => dispatch(stopImpersonation())}
          style={tw`bg-gray-900 px-3 py-1 rounded`}
        >
          <Text style={tw`text-white font-600`}>Volver</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
}
